import appConfig from 'const/app.const';
import env from 'utils/env';
import axios from 'axios';
import { filterEmptyParams } from 'utils/utils';
import Native from 'utils/nativeProxy';
import getRiskParam from '@hb/risk-param/lib/h5';
import { mainStoreWithoutHook as mainStore } from '@/stores';
import EasyLogin from '@hb/easy-login';
import Mock, { MockMap } from 'const/mock';
import { getMockParams } from '@hb/mockInitSDK';
// import { createHashHistory } from 'history';

function encodeRequestData(
  data: any,
  needLogin: boolean,
  autoEasyLogin?: boolean,
  noNeedToken?: boolean,
) {
  return new Promise((resolve, reject) => {
    // resolve({
    //   ...data,
    //   token: '7b1f7da4383e4fcca56528e9aa27d27f',
    // });
    // return;
    if (mainStore.userInfo.token && !noNeedToken) {
      const { token, ticket } = mainStore.userInfo;
      resolve({
        ...data,
        token,
        ticket,
      });
    } else if (needLogin) {
      Native.getTokenAndKey(needLogin)
        .then((auth: any) => {
          Object.assign(mainStore.userInfo, {
            token: auth.token,
            ticket: auth.ticket,
            guid: auth.guid,
            key: auth,
            mobile: auth.mobile,
          });
          resolve({
            ...data,
            token: auth.token,
            ticket: auth.ticket,
          });
        })
        .catch(() => {
          if (autoEasyLogin && !env.isEasyBikeApp) {
            EasyLogin.signIn({
              codeEnv: process.env.REACT_APP_ENV || 'pro',
              loginTitle: '欢迎使用哈啰助力车',
            });
          }
          reject(new Error('请登录！'));
        });
    } else {
      resolve(data);
    }
  });
}

// 获取风控参数
async function getRiskParamWithLocation(needRiskControlData: boolean = false) {
  if (!needRiskControlData) {
    return {};
  }
  try {
    let deviceHash = '';
    // 获取 deviceHash
    if (env.isEasyBikeApp) {
      const {
        'fingerprint-hash': fingerprintHash = '',
      } = (await Native.getDeviceFingerprintHash()) as any;
      deviceHash = fingerprintHash;
    }
    const { longitude, latitude } = await Native.getCityInfo();
    const params = await getRiskParam({
      deviceLon: longitude || '',
      deviceLat: latitude || '',
      systemCode: 63,
      deviceHash,
    });
    return filterEmptyParams(params);
  } catch (ex) {
    console.error('getRiskParamWithLocationError', ex);
    return {};
  }
}

const { CancelToken } = axios;

export default new (class {
  config: any;

  constructor() {
    this.config = appConfig;
  }

  getTotalUrl(params: any, config: any) {
    const apiHost = config?.apiServer || this.config.API;
    if (Mock && env.codeEnv !== 'pro') {
      // @ts-ignore
      return `${MockMap[params.action]}?${params.action}`;
    }
    return `${apiHost}?${params.action}`;
  }

  base(
    method: string,
    params: any,
    config = { isFilterParams: false },
    needLogin = false,
    autoEasyLogin?: boolean,
    noNeedToken = false,
  ) {
    return new Promise(async (resolve, reject) => {
      const canceller = CancelToken.source();
      const needRiskControlData = !!params.needRiskControlData;
      const newConfig = {
        method,
        url: this.getTotalUrl(params, config),
        headers: {
          'Content-type': 'application/json',
        },
        cancelToken: canceller.token,
        ...config,
      };
      let requestData = {
        version: env.appVersion,
        from: 'h5',
        systemCode: 63,
        osSystemCode: env.osSystemCode,
        platform: env.platformCode || 8,
        riskControlData: await getRiskParamWithLocation(needRiskControlData),
        ...params,
      };
      console.info(requestData.riskControlData);
      requestData = filterEmptyParams(requestData);

      encodeRequestData(requestData, needLogin, autoEasyLogin, noNeedToken)
        .then((data) => {
          // @ts-ignore
          const { url, data: mockData } = getMockParams(newConfig.url, data);
          newConfig.url = url;
          // @ts-ignore
          axios({ data: mockData, ...newConfig })
            .then((response) => {
              const responseData = response.data || {};
              const { code } = responseData;
              if (code === 0) {
                resolve(responseData.data);
                // 103代表必须要登录
              } else if (code === 103 && needLogin) {
                if (autoEasyLogin && !env.isEasyBikeApp) {
                  EasyLogin.signIn({
                    codeEnv: process.env.REACT_APP_ENV || 'pro',
                  });
                }
              } else {
                reject(responseData);
              }
            })
            .catch(reject);
        })
        .catch(reject);
    });
  }

  get(params = {}, config: any, needLogin: boolean, autoEasyLogin: boolean) {
    return this.base('get', params, config, needLogin, autoEasyLogin);
  }

  // 默认params为空对象，方便后台统计操作日志
  post(
    params = {},
    config?: any,
    needLogin = false,
    autoEasyLogin?: boolean,
    noNeedToken = false,
  ): Promise<any> {
    return this.base(
      'post',
      params,
      config,
      needLogin,
      autoEasyLogin,
      noNeedToken,
    );
  }
})();
